<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12">
      <h3 class="page-header">{{headerText}}</h3>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <mat-label>Select Table: </mat-label>
      <mat-form-field appearance="fill">
        <mat-select panelClass="long-panel" name="Select Table" (selectionChange)="getSelectedTable($event)" >
          <mat-option *ngFor="let t of tableDropDownItems" [value]="t.name">
            {{ t.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- showClearanceStatusTable -->
  <div class="row" *ngIf="showClearanceStatusTable">
    <div class="col-xs-12">
      <clearance-status-table></clearance-status-table>
    </div>
  </div>

  <!-- showDepartmentsTable -->
  <div class="row" *ngIf="showDepartmentsTable">
    <div class="col-xs-12">
      <departments-table></departments-table>
    </div>
  </div>

  <!-- showEeoTypeTable -->
  <div class="row" *ngIf="showEeoTypeTable">
    <div class="col-xs-12">
      <eeo-type-table></eeo-type-table>
    </div>
  </div>

  <!-- showEmpJobAssignmentsTable -->
  <div class="row" *ngIf="showEmpJobAssignmentsTable">
    <div class="col-xs-12">
      <employee-job-assignments-table></employee-job-assignments-table>
    </div>
  </div>

  <!-- showEmpStatusTable -->
  <div class="row" *ngIf="showEmpStatusTable">
    <div class="col-xs-12">
      <employee-status-table></employee-status-table>
    </div>
  </div>

  <!-- showEmploymentStatusTable -->
  <div class="row" *ngIf="showEmploymentStatusTable">
    <div class="col-xs-12">
      <employment-status-table></employment-status-table>
    </div>
  </div>

  <!-- showEmploymentTypeTable -->
  <div class="row" *ngIf="showEmploymentTypeTable">
    <div class="col-xs-12">
      <employment-type-table></employment-type-table>
    </div>
  </div>

  <!-- showFyPayRatesTable -->
  <div class="row" *ngIf="showFyPayRatesTable">
    <div class="col-xs-12">
      <fy-pay-rates-table></fy-pay-rates-table>
    </div>
  </div>

  <!-- showGenderTypeTable -->
  <div class="row" *ngIf="showGenderTypeTable">
    <div class="col-xs-12">
      <gender-type-table></gender-type-table>
    </div>
  </div>

  <!-- showJobCategoriesTable -->
  <div class="row" *ngIf="showJobCategoriesTable">
    <div class="col-xs-12">
      <job-categories-table></job-categories-table>
    </div>
  </div>

  <!-- showJobTitlesTable -->
  <div class="row" *ngIf="showJobTitlesTable">
    <div class="col-xs-12">
      <job-titles-table></job-titles-table>
    </div>
  </div>

  <!-- showMaritalStatusTable -->
  <div class="row" *ngIf="showMaritalStatusTable">
    <div class="col-xs-12">
      <marital-status-table></marital-status-table>
    </div>
  </div>

  <!-- showOccStatusTable -->
  <div class="row" *ngIf="showOccStatusTable">
    <div class="col-xs-12">
      <occ-status-table></occ-status-table>
    </div>
  </div>

  <!-- showOtherSpecialtyTypeTable -->
  <div class="row" *ngIf="showOtherSpecialtyTypeTable">
    <div class="col-xs-12">
      <other-specialty-type-table></other-specialty-type-table>
    </div>
  </div>

  <!-- showPscTypeTable -->
  <div class="row" *ngIf="showPscTypeTable">
    <div class="col-xs-12">
      <psc-type-table></psc-type-table>
    </div>
  </div>

  <!-- showShareholderTypeTable -->
  <div class="row" *ngIf="showShareholderTypeTable">
    <div class="col-xs-12">
      <shareholder-type-table></shareholder-type-table>
    </div>
  </div>

  <!-- showUnionAffiliationTable -->
  <div class="row" *ngIf="showUnionAffiliationTable">
    <div class="col-xs-12">
      <union-affiliation-table></union-affiliation-table>
    </div>
  </div>

  <!-- showWorkSectionsTable -->
  <div class="row" *ngIf="showWorkSectionsTable">
    <div class="col-xs-12">
      <work-sections-table></work-sections-table>
    </div>
  </div>
</div>